import { render, staticRenderFns } from "./GiftPurchaseList.vue?vue&type=template&id=6a536ebe&scoped=true&"
import script from "./GiftPurchaseList.vue?vue&type=script&lang=js&"
export * from "./GiftPurchaseList.vue?vue&type=script&lang=js&"
import style0 from "./GiftPurchaseList.vue?vue&type=style&index=0&id=6a536ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a536ebe",
  null
  
)

export default component.exports